import type {
  Builder,
  EditCover,
  EditPicture,
  InjectedProfilePage,
} from '../types';

class ProfilePageBuilder implements Builder<InjectedProfilePage> {
  private editCover: EditCover = null;
  private editPicture: EditPicture = null;
  private isSaving = false;
  private isEditing = false;
  private isCoverLoading = false;
  private isCoverRepositionMode = false;
  private isProfilePreview = false;

  build = (): InjectedProfilePage => ({
    editCover: this.editCover,
    editPicture: this.editPicture,
    isSaving: this.isSaving,
    isEditing: this.isEditing,
    isCoverLoading: this.isCoverLoading,
    isCoverRepositionMode: this.isCoverRepositionMode,
    isProfilePreview: this.isProfilePreview,
  });

  withEditPicture = (editPicture: EditPicture) => {
    this.editPicture = editPicture;
    return this;
  };

  withEditCover = (editCover: EditCover) => {
    this.editCover = editCover;
    return this;
  };

  withIsEditing = (isEditing: boolean) => {
    this.isEditing = isEditing;
    return this;
  };

  withIsCoverRepositionMode = (isCoverRepositionMode: boolean) => {
    this.isCoverRepositionMode = isCoverRepositionMode;
    return this;
  };
}

export default ProfilePageBuilder;
